module.exports = __webpack_public_path__ + "img/jacques_vabre-producteurs.7572af8f.jpg";